<script>
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import VFormModified from "@/components/commonComponents/VFormModified.vue";
import CommonRules from "@/mixins/CommonRules";
import QuotesModalCommon from "@/components/Quotes/QuotesModalCommon.vue";
import QuotesModalVideo from "@/components/Quotes/QuotesModalVideo.vue";
import QuotesModalPhoto from "@/components/Quotes/QuotesModalPhoto.vue";
import UserAuth from "@/mixins/UserAuth";
import Comments from "@/components/commonComponents/Comments.vue";
import History from "@/components/commonComponents/History.vue";
import QuotesModalSvg from "@/components/Quotes/QuotesModalSvg.vue";
import BpApproveDecline from "@/components/commonComponents/BpApproveDecline.vue";
// import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";
import roscongressUrl from "@/utils/roscongressUrl";
import QuotesModalTranscription from "@/components/Quotes/QuotesModalTranscription.vue";
import BpStatusStepper from "@/components/commonComponents/BpStatusStepper.vue";
import VBtnMenu from "@/components/commonComponents/VBtnMenu.vue";
import VBtnMenuItem from "@/components/commonComponents/VBtnMenuItem.vue";
import _ from "lodash";
import ComponentsKeys from "@/mixins/ComponentsKeys";

export default {
    name: "QuotesModal",
    components: {
        VBtnMenuItem,
        VBtnMenu,
        BpStatusStepper,
        QuotesModalTranscription,
        // VIconTooltip,
        BpApproveDecline,
        QuotesModalSvg,
        History,
        Comments,
        QuotesModalPhoto,
        QuotesModalVideo,
        QuotesModalCommon,
        AjaxLoad,
        VFormModified,
    },
    mixins: [
        CommonRules,
        UserAuth,
        ComponentsKeys,
    ],
    props: {
        idProject: {
            type: String,
        },
        idEventsBitrix: {
            type: Number,
        },
        idForumsBitrix: {
            type: Number,
        },
    },
    data() {
        return {
            isShow: false,
            isResolved: false,
            isValid: false,
            isSubmit: false,
            isCopy: false,
            wasModified: false,
            result: false,
            idQuotes: null,
            loadPromise: null,
            original: {},
            data: {},
            notifyOptions: {
                title: 'Цитата',
            },
            tab: 'common',
            tabs: {
                video: {
                    hasVideo: false,
                },
            },
            isLoadingSvg: false,
            componentsKeys: {
                svg: this.getRandomKey('svg'),
            },
        };
    },
    computed: {
        isDisabled() {
            return this.isNew ?
                !this.user?.permissions?.byModule?.quotes?.canCreate :
                !(this.user?.permissions?.byModule?.quotes?.canUpdate && this.data?.permissions?.canUpdate);
        },
        isCanSubmit() {
            return !this.isDisabled && this.isValid && (this.wasModified || this.isNew) && !this.isSubmit && this.isResolved;
        },
        isCanAction() {
            return !this.wasModified && !this.isSubmit && this.isResolved && !this.isNew && this.isValid;
        },
        isCanPublish() {
            return this.isCanAction && this.data?.permissions?.canPublish;
        },
        isNew() {
            return !this.idQuotes || this.isCopy;
        },
        isLoading() {
            return !this.isResolved || this.isSubmit;
        },
        loadUrl() {
            return this.$apiUrl.getQuoteUrl({
                id_project: this.idProject,
                id: this.idQuotes,
            });
        },
        saveUrl() {
            return this.isNew ?
                this.$apiUrl.getQuotesUrl({
                    id_project: this.idProject,
                }) :
                this.loadUrl;
        },
        svgUrl() {
            return this.$apiUrl.getQuoteSvgFullUrl({id_project: this.idProject, id: this.idQuotes})
        },
        roscongressBrightQuoteUrl() {
            const idBrightQuotes = this.data?.id_bright_quotes;
            return idBrightQuotes && roscongressUrl.getBrightQuoteUrl({id_bright_quotes: idBrightQuotes});
        },
        roscongressBrightQuoteBitrixUrl() {
            const idBrightQuotes = this.data?.id_bright_quotes;
            return idBrightQuotes && roscongressUrl.getBrightQuoteBitrixUrl({id_bright_quotes: idBrightQuotes});
        },
        hasPreview() {
            return !this.isNew && !['history', 'transcription'].includes(this.tab);
        },
        dialogContentClass() {
            return this.hasPreview ? 'has-preview' : null;
        },
        dialogMaxWidth() {
            return this.isNew ? 900 : (this.hasPreview ? '64vw' : '90vw');
        },
    },
    watch: {
        isShow(v) {
            if (!v) {
                this.resolve(this.result);
                this.result = false;
            }
        },
        tab() {
            // При смене вкладки возвращаем фокус диалогу
            this.$nextTick(() => {
                this.$refs.dialogContent?.focus();
                this.$refs.dialogContent?.$el?.focus();
            });
        },
    },
    methods: {
        show(idQuotes, data = {}, isCopy = false) {
            this.idQuotes = idQuotes;
            this.isCopy = isCopy;
            if (!idQuotes) {
                data = Object.assign(
                    {
                        is_declined: 0,
                        is_bright: 1,
                        is_summary: 0,
                        is_ai: 0,
                        id_sessions_summaries_theses: null,
                    },
                    data
                );
            }
            this.loadPromise = !idQuotes ? Promise.resolve({data: {data}}) : this.$api.get(this.loadUrl);
            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        doSave(callback) {
            this.isSubmit = true;
            const method = this.isNew ? 'post' : 'put';
            this.$api[method](this.saveUrl, this.data, true)
                .then((response) => {
                    this.result = response;
                    this.notifySuccess('Успешно сохранена');
                    if (_.isFunction(callback)) {
                        callback(response);
                    }
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onClickSaveAndClose() {
            this.doSave(this.close);
        },
        onClickSave() {
            this.doSave((response) => {
                this.original = response.data.data;
                this.idQuotes = this.original.id;
                this.isCopy = false;
                this.updateComponentKey('svg');
                this.$refs.history?.load();
            });
        },
        onClickCancel() {
            this.close();
        },
        close() {
            this.isShow = false;
        },
        isDisabledField(field) {
            return this.isDisabled || (!this.isNew && !this.data?.permissions?.isEditableField[field]);
        },
        onClickPublish() {
            this.isSubmit = true;
            this.$api.put(this.svgUrl)
                .then(() => {
                    this.notifySuccess('Успешно опубликована.');
                    this.reload();
                })
                .catch(this.notifyError)
                .finally(() => {
                    this.isSubmit = false;
                });
        },
        onConfirmBpApproveDecline(data) {
            const url = this.$apiUrl.getQuoteApproveDeclineUrl({
                id: this.idQuotes,
                id_project: this.idProject,
                action: data.action,
                role: data.role,
            });
            return this.$api.put(url, data.form)
        },
        onSuccessBpApproveDecline() {
            this.reload();
        },
        onWrapperKeydown(e) {
            if (e.key === 'Escape' && !this.wasModified) {
                this.close();
            }
        },
        reload() {
            this.loadPromise = this.$api.get(this.loadUrl);
            this.$refs.comments.load();
            this.$refs.history?.load();
            this.result = true;
        },
        onInputResponse() {
            if (this.isCopy) {
                this.idQuotes = 0;
            }
        },
    },
}
</script>

<template>
    <div>
        <v-dialog
            v-if="isShow"
            v-model="isShow"
            :persistent="wasModified"
            :max-width="dialogMaxWidth"
            scrollable
            :content-class="dialogContentClass"
            ref="dialog"
        >
            <div v-if="hasPreview"
                class="svg-preview"
            >
                <quotes-modal-svg
                    :key="componentsKeys.svg"
                    :id-project="idProject"
                    :id-quotes="idQuotes"
                    :value="data"
                    :is-disabled-field="isDisabledField"
                    :was-modified="wasModified"
                ></quotes-modal-svg>
            </div>
            <ajax-load
                v-model="original"
                :promise="loadPromise"
                :transform="response => response.data.data"
                :resolved.sync="isResolved"
                @input="onInputResponse"
            >
                <v-card :loading="isLoading">
                    <v-card-title>
                        {{ isNew ? 'Новая цитата' : ['Цитата #', this.idQuotes].join("") }}

                        <!--                    <v-icon-tooltip
                                                v-if="roscongressBrightQuoteUrl"
                                                :href="roscongressBrightQuoteUrl"
                                                target="_blank"
                                                icon="mdi-open-in-new"
                                            >
                                                Открыть цитату на сайте
                                            </v-icon-tooltip>-->

                        <v-spacer></v-spacer>

                        <bp-status-stepper
                            v-if="!isNew"
                            :data="data"
                            :published-url="roscongressBrightQuoteUrl"
                            :published-bitrix-url="roscongressBrightQuoteBitrixUrl"
                            published-url-tooltip="Открыть цитату на Портале"
                        ></bp-status-stepper>
                    </v-card-title>
                    <div ref="dialogContent" tabindex="0" @keydown="onWrapperKeydown">
                        <v-tabs v-model="tab">
                            <v-tab tab-value="common">Общее</v-tab>
                            <v-tab tab-value="photo">Фото</v-tab>
                            <v-tab tab-value="video" :disabled="!tabs.video.hasVideo">Видео</v-tab>
                            <v-tab tab-value="transcription" @change="() => $refs?.quotesModalTranscription?.rewind()">
                                Транскрибация
                            </v-tab>
                            <v-tab v-if="!isNew" tab-value="history">История</v-tab>
                        </v-tabs>
                    </div>
                    <v-card-text>
                        <v-container class="pa-0">
                            <v-row no-gutters>
                                <v-col>
                                    <v-form-modified
                                        v-model="isValid"
                                        :original="original"
                                        :modified.sync="data"
                                        :was-modified.sync="wasModified"
                                        :disabled="isLoading"
                                    >
                                        <v-tabs-items v-model="tab">
                                            <v-tab-item value="common">
                                                <quotes-modal-common
                                                    v-model="data"
                                                    :id-project="idProject"
                                                    :id-events-bitrix="idEventsBitrix"
                                                    :id-forums-bitrix="idForumsBitrix"
                                                    :is-disabled-field="isDisabledField"
                                                    :id-quotes="idQuotes"
                                                ></quotes-modal-common>
                                            </v-tab-item>
                                            <v-tab-item value="photo">
                                                <quotes-modal-photo
                                                    v-model="data"
                                                    :id-project="idProject"
                                                    :is-disabled-field="isDisabledField"
                                                    ref="photo"
                                                ></quotes-modal-photo>
                                            </v-tab-item>
                                            <v-tab-item value="video" eager>
                                                <quotes-modal-video
                                                    v-model="data"
                                                    :id-events-bitrix="idEventsBitrix"
                                                    :id-forums-bitrix="idForumsBitrix"
                                                    :is-disabled-field="isDisabledField"
                                                    :has-video.sync="tabs.video.hasVideo"
                                                    :active="tab === 'video'"
                                                ></quotes-modal-video>
                                            </v-tab-item>
                                            <v-tab-item value="transcription">
                                                <quotes-modal-transcription
                                                    ref="quotesModalTranscription"
                                                    :id-project="idProject"
                                                    :id-session="data?.id_sessions"
                                                    :time="data?.start_time"
                                                ></quotes-modal-transcription>
                                            </v-tab-item>
                                            <v-tab-item value="history">
                                                <history
                                                    ref="history"
                                                    :url="$apiUrl.getQuoteHistoryUrl({id_project: idProject, id: idQuotes})"
                                                ></history>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-form-modified>
                                </v-col>
                                <v-col v-if="!isNew" cols="4">
                                    <v-card height="100%" flat>
                                        <v-toolbar flat>
                                            <v-toolbar-title>Комментарии</v-toolbar-title>
                                        </v-toolbar>
                                        <comments
                                            v-if="idProject && idQuotes"
                                            ref="comments"
                                            :url="$apiUrl.getQuoteCommentsUrl({id_project: idProject, id: idQuotes})"
                                        ></comments>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <bp-approve-decline
                            :is-can-action="isCanAction"
                            :permissions="data?.permissions"
                            @confirm="onConfirmBpApproveDecline"
                            @success="onSuccessBpApproveDecline"
                            approve-question="Вы уверены что хотите отправить цитату на утверждение?"
                            approve-as-moderator-question="Вы уверены что хотите одобрить цитату?"
                            decline-question="Вы уверены что хотите отклонить цитату?"
                        >
                            <template v-slot:append>
                                <v-btn
                                    v-if="isCanPublish"
                                    :disabled="!isCanPublish"
                                    @click="onClickPublish"
                                >
                                    Опубликовать
                                </v-btn>
                            </template>
                        </bp-approve-decline>


                        <v-spacer></v-spacer>

                        <v-btn @click="onClickCancel">
                            Отмена
                        </v-btn>

                        <v-btn-menu
                            :disabled="!isCanSubmit"
                            @click="onClickSaveAndClose"
                            color="primary"
                        >
                            Сохранить
                            <template v-slot:menu>
                                <v-btn-menu-item
                                    @click="onClickSaveAndClose"
                                >
                                    ... и закрыть
                                </v-btn-menu-item>
                                <v-btn-menu-item
                                    @click="onClickSave"
                                >
                                    ... и продолжить
                                </v-btn-menu-item>
                            </template>
                        </v-btn-menu>

                    </v-card-actions>

                </v-card>
            </ajax-load>
        </v-dialog>

    </div>
</template>

<style scoped lang="scss">
.v-tabs {
    border-bottom: 1px solid #c0c0c044;
    margin-bottom: 20px;
    ::v-deep {
        .v-tab--active {
           color: rgb(165, 14, 45) !important;
        }
    }
}

::v-deep {
    .has-preview {
        // node_modules/vuetify/src/components/VDialog/VDialog.sass:97
        @keyframes animate-dialog-quotes-has-preview {
            0% {
                transform: translateX(-16vw) scale(1);
            }
            50% {
                transform: translateX(-16vw) scale(1.03);
            }
            100% {
                transform: translateX(-16vw) scale(1);
            }
        }
        &.v-dialog--animated {
            animation-name: animate-dialog-quotes-has-preview;
        }
        transform: translateX(-16vw);
        overflow-y: visible;
    }

    .svg-preview {
        position: fixed;
        right: -50%;
        
        z-index: 1000;
        max-width: calc(90vw / 3);
        min-width: calc(90vw / 3);
        width: calc(90vw / 3);
    }
}

::v-deep {
    .v-card__actions {
        .v-btn {
            &.v-btn-with-menu {
                .v-btn__content {
                    .v-divider--vertical {
                        margin: 0 0 0 8px;
                    }
                }
            }
        }
    }
}
</style>
